import { ViewChild, AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IApp } from '@core/models/app.interfaces';
import IDocument = IApp.IDocument;
import { Dialog, DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from '@shared/components/documents/documents.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-credit-creation-additional-details',
  templateUrl: './compliance-report-additional-details.component.html',
  styleUrls: ['./compliance-report-additional-details.component.scss'],
  imports: [TranslateModule, DialogModule, DocumentsComponent, CommonModule, FormlyModule,
    FormsModule, ReactiveFormsModule ]
})
export class ComplianceReportAdditionalDetailsComponent implements OnInit, AfterViewInit {

  @ViewChild('dialog', { static: false }) dialog: Dialog;

  public currentStepObj;
  public visible = true;
  public documents: IDocument[];
  public isDocumentUploadInProgress = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ComplianceReportAdditionalDetailsComponent>,
  ) { }

  ngOnInit() {
    this.currentStepObj = this.data.currentStepObj;
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.dialog.el.nativeElement.querySelector('.p-dialog-content').scrollTo(0, 0);
    }, 500);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currentStepObj.additionalDetailsForm.disable();
    });
  }

  documentUploadHandler(documentResult: IApp.IEmmitedDocs): void {
    this.documents = documentResult.docs;
    this.isDocumentUploadInProgress = documentResult.docs
      .filter(document => document._uploadStatus)
      .some(document => document._uploadStatus !== 'CLEAN');
  }

  public close(): void {
    this.dialogRef.close(false);
  }

}
